import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "select-kondektur" }
const _hoisted_2 = { style: {"min-height":"20vh"} }
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = {
  class: "w-full",
  style: {"padding":"0px 5px 8px 5px","border-bottom":"1px solid #cfd8dc"}
}
const _hoisted_5 = { class: "flex w-full items-center justify-between" }
const _hoisted_6 = { class: "text-2xl font-bold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_8 = { class: "text-sm font-normal" }
const _hoisted_9 = { class: "mb-5" }
const _hoisted_10 = { class: "mb-8" }
const _hoisted_11 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Pilih Kondektur'), -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectFetch = _resolveComponent("SelectFetch")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_HjpAlertModal = _resolveComponent("HjpAlertModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ModalDefault, {
      show: _ctx.showModal,
      onHideDialog: _ctx.closeDialog
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.headerLabel), 1),
                _hoisted_7
              ]),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.headerDescription), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_SelectFetch, {
                  modelValue: _ctx.selectedKondektur,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedKondektur) = $event)),
                  "input-id": "class-input",
                  endpoint: "/management/v1/User/all-user",
                  searchCustom: [['activeOnly', '=', true], ['roles', '=', 'Condectur']],
                  fieldLabel: (v) => v.Fullname,
                  clearable: false,
                  searchFields: ['Name'],
                  placeholder: "Pilih kondektur"
                }, null, 8, ["modelValue", "fieldLabel"]),
                (_ctx.showErrorMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString('Kondektur tidak boleh kosong')))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_Button, {
                  class: "mb-2 sm:mb-0 flex gap-2 w-full",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedKondektur ? _ctx.onSubmit() : _ctx.showError()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "onHideDialog"]),
    _createVNode(_component_HjpAlertModal, {
      show: _ctx.modalConfirmation.show,
      title: _ctx.modalConfirmation.title,
      subTitle: _ctx.modalConfirmation.subTitle,
      subTitleHtml: _ctx.modalConfirmation.subTitleHtml,
      btnSubmitTitle: _ctx.modalConfirmation.btnSubmitTitle,
      imgContent: _ctx.modalConfirmation.imgContent,
      onHideDialog: _ctx.hideConfirmDialog,
      onOnSubmit: _ctx.hideConfirmDialog
    }, null, 8, ["show", "title", "subTitle", "subTitleHtml", "btnSubmitTitle", "imgContent", "onHideDialog", "onOnSubmit"])
  ]))
}